function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M29.1171 6.30002C29.1336 6.30122 29.1502 6.30243 29.167 6.30243C29.1956 6.30243 29.2241 6.30002 29.2521 6.29611C30.0003 6.31144 30.5991 6.92169 30.6 7.66992C30.6 8.00992 30.8757 8.28558 31.2157 8.28558C31.5557 8.28558 31.8313 8.00992 31.8313 7.66992C31.8298 6.44612 30.9779 5.38735 29.7827 5.12402V4.53241C29.7827 4.19241 29.507 3.91675 29.167 3.91675C28.827 3.91675 28.5513 4.19241 28.5513 4.53241V5.15197C27.2876 5.48986 26.4699 6.71246 26.6403 8.00962C26.8108 9.30677 27.9164 10.2766 29.2247 10.2766C29.9844 10.2766 30.6 10.8925 30.6 11.6522C30.6 12.4115 29.9844 13.0275 29.2247 13.0275C28.4651 13.0275 27.8494 12.4115 27.8494 11.6522C27.8494 11.3122 27.5737 11.0365 27.2337 11.0365C26.8938 11.0365 26.6181 11.3122 26.6181 11.6522C26.6196 12.8318 27.412 13.8638 28.5513 14.1701V14.8447C28.5513 15.1847 28.827 15.4604 29.167 15.4604C29.507 15.4604 29.7827 15.1847 29.7827 14.8447V14.1984C31.0828 13.9137 31.9597 12.695 31.8163 11.3717C31.6732 10.0484 30.5558 9.04553 29.2247 9.04584C28.4861 9.04614 27.8792 8.46294 27.85 7.72493C27.8211 6.98693 28.3806 6.35774 29.1171 6.30032V6.30002Z",
  fill: "url(#paint0_linear)"
}), React.createElement("path", {
  d: "M29.2597 0.906616C25.4723 0.906616 22.2401 3.37797 21.0292 6.68714H5.74866C5.41017 6.68714 5.1354 6.99226 5.133 7.33045L4.9875 28.9278H0.631893C0.291897 28.9278 0 29.174 0 29.5146V32.2553C0.00781595 34.8355 2.03997 36.9551 4.61744 37.0718V37.0853H23.6259V37.0673C23.7798 37.073 23.8433 37.0853 23.9407 37.0853H23.9539C26.6216 37.0811 28.7821 34.9173 28.7821 32.2496V18.3925C28.936 18.4009 29.0989 18.4054 29.2582 18.4054C34.078 18.4054 38.0001 14.4758 38.0001 9.65571C38.0001 4.83595 34.0798 0.906616 29.2597 0.906616ZM4.85162 35.854H4.84772C2.85614 35.8513 1.24034 34.2409 1.23132 32.249V30.1591H19.0854V32.2403C19.0863 33.5251 19.5995 34.7567 20.511 35.6625C20.5756 35.7271 20.6558 35.777 20.7235 35.854H4.85162ZM27.5508 32.249C27.5511 34.2373 25.9413 35.8501 23.9533 35.854H23.9416C21.9455 35.8504 20.3267 34.2367 20.3168 32.2409V29.5146C20.3219 29.3571 20.2617 29.2047 20.1502 29.0934C20.0387 28.9822 19.8863 28.9224 19.7291 28.9278H6.21882L6.36011 7.91845H20.6874C20.5783 8.48211 20.5218 9.05448 20.5188 9.62835C20.5176 10.8419 20.7707 12.042 21.2619 13.1516H15.4468C15.1065 13.1516 14.8311 13.4272 14.8311 13.7672C14.8311 14.1072 15.1065 14.3829 15.4468 14.3829H21.9299C23.2 16.3802 25.2303 17.7726 27.5508 18.2386V32.249ZM29.2597 17.1744C25.1125 17.1744 21.7501 13.8123 21.7504 9.66472C21.7504 5.51714 25.1125 2.15507 29.26 2.15507C33.4073 2.15507 36.7694 5.51744 36.7694 9.66472C36.7649 13.8102 33.4055 17.1699 29.2597 17.1744Z",
  fill: "url(#paint1_linear)"
}), React.createElement("path", {
  d: "M11.4949 17.249C10.4082 17.249 9.52441 18.1049 9.52441 19.157C9.52441 20.2092 10.4082 21.065 11.4949 21.065C12.5817 21.065 13.4658 20.2092 13.4658 19.157C13.4658 18.1049 12.5817 17.249 11.4949 17.249ZM11.4949 19.8337C11.087 19.8337 10.7557 19.5301 10.7557 19.157C10.7557 18.7837 11.0873 18.4803 11.4949 18.4803C11.9026 18.4803 12.2345 18.784 12.2345 19.157C12.2345 19.5301 11.9026 19.8337 11.4949 19.8337Z",
  fill: "url(#paint2_linear)"
}), React.createElement("path", {
  d: "M14.8311 19.1542C14.8311 19.4942 15.1064 19.7699 15.4467 19.7699H23.6547C23.9947 19.7699 24.2704 19.4942 24.2704 19.1542C24.2704 18.8142 23.9947 18.5386 23.6547 18.5386H15.4467C15.1064 18.5386 14.8311 18.8142 14.8311 19.1542Z",
  fill: "url(#paint3_linear)"
}), React.createElement("path", {
  d: "M11.4949 11.8971C10.4082 11.8971 9.52441 12.7532 9.52441 13.8054C9.52441 14.8576 10.4082 15.7134 11.4949 15.7134C12.5817 15.7134 13.4658 14.8576 13.4658 13.8054C13.4658 12.7532 12.5817 11.8971 11.4949 11.8971ZM11.4949 14.4821C11.087 14.4821 10.7557 14.1785 10.7557 13.8054C10.7557 13.4323 11.0873 13.1284 11.4949 13.1284C11.9026 13.1284 12.2345 13.432 12.2345 13.8054C12.2345 14.1785 11.9026 14.4824 11.4949 14.4824V14.4821Z",
  fill: "url(#paint4_linear)"
}), React.createElement("path", {
  d: "M11.4949 22.6002C10.4082 22.6002 9.52441 23.4561 9.52441 24.5082C9.52441 25.5604 10.4082 26.4162 11.4949 26.4162C12.5817 26.4162 13.4658 25.5604 13.4658 24.5082C13.4658 23.4561 12.5817 22.6002 11.4949 22.6002ZM11.4949 25.1849C11.087 25.1849 10.7557 24.8816 10.7557 24.5082C10.7557 24.1352 11.0873 23.8315 11.4949 23.8315C11.9026 23.8315 12.2345 24.1352 12.2345 24.5082C12.2345 24.8813 11.9026 25.1849 11.4949 25.1849Z",
  fill: "url(#paint5_linear)"
}), React.createElement("path", {
  d: "M23.6547 23.9255H15.4467C15.1064 23.9255 14.8311 24.2012 14.8311 24.5412C14.8311 24.8812 15.1064 25.1568 15.4467 25.1568H23.6547C23.9947 25.1568 24.2704 24.8812 24.2704 24.5412C24.2704 24.2012 23.9947 23.9255 23.6547 23.9255Z",
  fill: "url(#paint6_linear)"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 27.7255,
  y1: 3.91675,
  x2: 31.3493,
  y2: 4.16416,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 8.07257,
  y1: 0.906618,
  x2: 33.9553,
  y2: 5.01609,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 10.3617,
  y1: 17.249,
  x2: 13.0484,
  y2: 17.6685,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 16.8363,
  y1: 18.5386,
  x2: 19.6498,
  y2: 21.7988,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 10.3617,
  y1: 11.8971,
  x2: 13.0484,
  y2: 12.3165,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 10.3617,
  y1: 22.6002,
  x2: 13.0484,
  y2: 23.0197,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 16.8363,
  y1: 23.9255,
  x2: 19.6497,
  y2: 27.1858,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FDB451"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F48847"
})), React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 38,
  height: 38,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/bill.4c5b39fd.svg";
export { SvgComponent as ReactComponent };